module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div class=\"row\">\r\n    <div class=\"col-lg-12\">\r\n        <div id=\"actionTable\"></div>\r\n    </div>\r\n</div>\r\n<div class=\"row\" id=\"actionTableOperations\" style=\"display: none;\">\r\n    <div class=\"col-sm-12\">\r\n\r\n        <button type=\"button\" title=\"Add new action\" name=\"addAction\" title=\"Add action\" data-table-type=\"actionTable\" class=\"itemNew btn btn-default hvr-glow tbl-icon\">\r\n            <i class=\"fa pf-add\"></i>\r\n        </button>\r\n        <button disabled type=\"button\" title=\"Remove selected action\" title=\"Remove action\"  name=\"removeAction\" data-table-type=\"actionTable\" class=\"itemRemove btn btn-default hvr-glow tbl-icon\">\r\n            <i class=\"fa pf-delete icon-gradient\"></i>\r\n        </button>\r\n    </div>\r\n</div>")
  }
  return __output;

}